























































































































































import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import pxButton from '@/dex-shared/components/px-button.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import Loading from '@/dex-shared/components/Loading.vue';
import processString from '@/helpers/string';
import OptionModal from '@/components/modals/postgradEarlyGraduation/OptionModal.vue';
import RadioButton from '@/components/RadioButton.vue';
import PostgradEarlyGraduationRequestService from '@/helpers/pegasus-mustang/earlyGraduation/request';

interface PostgradMinPeriodInformation {
  id: number;
  title: string;
  minPeriod: number;
}

export default Vue.extend({
  components: {
    pxButton,
    pxCard,
    Loading,
    OptionModal,
    RadioButton,
  },

  data() {
    return {
      loaded: false,
      creating: true,
      pushingCourse: false,
      dropdownEnabled: false,
      searchCourse: '',
      savedDescomplicaCourse: {},
      hasDescomplicaCourse: false,
      openOptionModal: false,
      postgradMinPeriodChoosen: null,
      descomplicaCategorySlug: null,
      postgradMinPeriodError: false,
      savingPostgradMinPeriod: false,
      postgradStudyPlanningAvailable: false,
    };
  },

  computed: {
    ...mapState({
      categories: (state: any) => state.descomplica.categories,
      descomplicaCourses: (state: any) => state.descomplica.courses,
    }),
    ...mapGetters({
      course: 'currentCourse',
    }),
    descomplicaCourseList(): Array<{
      name: string;
      _id: string;
      slug: string;
    }> {
      if (this.searchCourse === '') return this.descomplicaCourses;
      return this.descomplicaCourses.filter(element => {
        const itemtoSearch = processString(this.searchCourse);
        const elementNormalized = processString(element.name);
        return elementNormalized.includes(itemtoSearch);
      });
    },
    postgradCourse(): boolean {
      return this.descomplicaCategorySlug === 'pos';
    },
    postgradMinPeriodInfo(): PostgradMinPeriodInformation[] {
      return [
        {
          id: 1,
          title: '3 meses',
          minPeriod: 3,
        },
        {
          id: 2,
          title: '6 meses',
          minPeriod: 6,
        },
        {
          id: 3,
          title: '12 meses',
          minPeriod: 12,
        },
      ];
    },
  },
  async created() {
    this.creating = this.$route.name === 'course_create';
    if (this.creating) {
      this.$store.commit('SET_EMPTY_COURSE');
    } else {
      let courseId = parseInt(this.$route.params.courseId);
      await this.$store.dispatch('PULL_COURSE', courseId);
      this.descomplicaCategorySlug = this.course.descomplicaCategorySlug;

      if (this.course && this.postgradCourse) {
        const [_info, minPeriod] = await Promise.all([
          this.$store.dispatch(
            'PULL_ACCESS_TO_POSTGRAD_STUDY_PLANNING',
            courseId,
          ),
          PostgradEarlyGraduationRequestService.getPostgradMinPeriodByCourseId(
            {
              courseId,
            },
          ),
        ]);
        this.postgradMinPeriodChoosen = this.postgradMinPeriodInfo.find(
          info => info.minPeriod === +minPeriod,
        );
        this.postgradStudyPlanningAvailable =  this.course.hasAccessToPostgradStudyPlanning;
      }
      //TODO no course found
    }

    await Promise.all([
      this.$store.dispatch('PULL_DESCOMPLICA_COURSES'),
      this.$store.dispatch('PULL_CATEGORIES'),
    ]);

    this.savedDescomplicaCourse = this.course.descomplicaCourseId
      ? this.selectedDecomplicaCourse(
          this.descomplicaCourses,
          this.course.descomplicaCourseId,
        )
      : {};
    this.hasDescomplicaCourse = !!this.course.descomplicaCourseId;
    this.loaded = true;
  },
  methods: {
    pushCourse: async function() {
      if (!this.hasDescomplicaCourse) this.course.descomplicaCourseId = null;

      if(!this.creating && this.descomplicaCategorySlug === 'pos' && !this.postgradMinPeriodChoosen) {
        alert(
          `Erro ao salvar o curso de pós-graduação.\n
          É necessário selecionar um tempo mínimo de conclusão ou alterar a categoria do curso.`,
        );
        return
      }
      //TODO valid course
      if (this.pushingCourse === false) {
        this.pushingCourse = true;
        this.course.descomplicaCategorySlug = this.descomplicaCategorySlug;
        this.course.hasAccessToPostgradStudyPlanning = this.postgradStudyPlanningAvailable;
        try {
          await this.$store.dispatch('PUSH_COURSE', this.course);
        } catch (err) {
          alert(
            `Algo deu errado ao salvar o curso.
            \nConfirme se todas as informações foram preenchidas e se o erro persistir envie essas informações para os desenvolvedores:
            \n${err}`,
          );
          this.pushingCourse = false;
          return
        }

        if(!this.course.id) return

        if (this.postgradCourse) {
          if (this.creating) {
            this.openOptionModal = true;
          } else {
            await this.savePostgradMinPeriodInformation();
          }
          return
        }
        this.pushingCourse = false;
        this.$router.push(`/curso/${this.course.id}`);
      }
    },
    goHome() {
      this.$router.push('/');
    },
    selectCourse(descomplicaCourse: {
      name: string;
      _id: string;
      slug: string;
    }) {
      this.course.descomplicaCourseId = descomplicaCourse._id;
      this.savedDescomplicaCourse = descomplicaCourse;
      this.dropdownEnabled = false;
    },
    toggleDropdown() {
      this.dropdownEnabled = !this.dropdownEnabled;
    },
    selectedDecomplicaCourse(
      descomplicaCourses: Array<{ name: string; _id: string; slug: string }>,
      descomplicaCourseId: string,
    ) {
      const descomplicaCourse = descomplicaCourses.find(course => {
        return course._id === descomplicaCourseId;
      });
      return descomplicaCourse;
    },
    async savePostgradMinPeriodInformation(option?: PostgradMinPeriodInformation) {
      const minPeriod = this.creating
        ? option.minPeriod
        : this.postgradMinPeriodChoosen?.minPeriod;

      if(minPeriod === undefined) {
        this.pushingCourse = false;
        return
      };

      this.savingPostgradMinPeriod = true;

      try {
        await PostgradEarlyGraduationRequestService.updateMinPeriodByCourseId(
          {
            courseId: this.course.id,
            minPeriod,
          },
        );
        this.$router.push(`/curso/${this.course.id}`);
      } catch (err) {
        this.savingPostgradMinPeriod = false;
        this.openOptionModal = true;
        this.postgradMinPeriodError = true;
      }
    },
    async closeOptionModal() {
      if(this.creating) {
        await this.removeCourseCreated();
      }
      this.openOptionModal = false;
      this.pushingCourse = false;
      this.postgradMinPeriodError = false;
    },
    async removeCourseCreated() {
      await this.$store.dispatch('DELETE_COURSE_BY_ID', this.course);
      this.course.id = null;
    },
  },
});
